module.exports = __webpack_public_path__ + "static/media/value-prop-link-arrow.50cd13f0.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/value-prop-link-arrow.svg
// module id = 1307
// module chunks = 0